import { Controller } from "@hotwired/stimulus"

let tickets = []
// Connects to data-controller="store-filter"
export default class extends Controller {
  static targets = ["input"]

  connect() {
    console.log("store filter connected")
    tickets = document.querySelectorAll('.ticket-filter')
    // console.log(tickets)
  }

  search() {
    const value = this.inputTarget.value
    // console.log(value + " is the value")
    // console.log(tickets.length)

    tickets.forEach(ticket =>{
      console.log(ticket.classList)
      if (value.length === 0 ) {
        this.clear()
      } else if (this.classFilter(ticket.classList, value.toLowerCase()) === true ){
        ticket.classList.remove('d-none')
      } else {
        ticket.classList.add('d-none')
      }
    })
  }

  classFilter(list, input){
    let match = false
    list.forEach( item =>{
      if (item.includes(input)){
        console.log("item match")
        match = true
      }
    })
    return match
  }

  clear(){
    tickets.forEach(ticket => {
      ticket.classList.remove('d-none')
    })
    this.inputTarget.value = ""
  }
}
